import { CircularProgress } from '@mui/material';
import React from 'react';
import { SECONDARY_BUTTON_HOVER_SX, StyledButton } from '../styles/StyledButtons';

interface HighlightGenerateButtonsProps {
  hasContent: boolean;
  isGenerating: boolean;
  isGeneratingPro: boolean;
  isCmsBusy: boolean;
  isSavingForGenerate: boolean;
  isSavingForGeneratePro: boolean;
  onGenerateFast: () => void;
  onGeneratePro: () => void;
  fastLabel?: string;
  proLabel?: string;
}

export default function HighlightGenerateButtons({
  hasContent,
  isGenerating,
  isGeneratingPro,
  isCmsBusy,
  isSavingForGenerate,
  isSavingForGeneratePro,
  onGenerateFast,
  onGeneratePro,
  fastLabel = 'Generate (Fast)',
  proLabel = 'Generate (Thinking)',
}: HighlightGenerateButtonsProps) {
  const noContentTitle = 'Add content to the update before generating a highlight card';

  return (
    <>
      <StyledButton
        noTopSpacing
        buttonVariant="inactiveOrCancel"
        sx={SECONDARY_BUTTON_HOVER_SX}
        onClick={onGenerateFast}
        disabled={isGenerating || isCmsBusy || !hasContent}
        title={!hasContent ? noContentTitle : undefined}
        startIcon={
          (isGenerating && !isGeneratingPro) || (isSavingForGenerate && !isSavingForGeneratePro) ? (
            <CircularProgress size={12} />
          ) : undefined
        }
      >
        {isGenerating && !isGeneratingPro
          ? 'Generating…'
          : isSavingForGenerate && !isSavingForGeneratePro
            ? 'Saving…'
            : fastLabel}
      </StyledButton>
      <StyledButton
        noTopSpacing
        buttonVariant="inactiveOrCancel"
        sx={SECONDARY_BUTTON_HOVER_SX}
        onClick={onGeneratePro}
        disabled={isGenerating || isCmsBusy || !hasContent}
        title={!hasContent ? noContentTitle : 'Use Gemini Thinking (Pro) for higher quality output'}
        startIcon={
          isGeneratingPro || isSavingForGeneratePro ? <CircularProgress size={12} /> : undefined
        }
      >
        {isGeneratingPro ? 'Generating…' : isSavingForGeneratePro ? 'Saving…' : proLabel}
      </StyledButton>
    </>
  );
}
